@if (googleMapsService.googleMapsLoaded | async) {
  <form [formGroup]="form" class="grid grid-cols-2 gap-x-20">
    <mat-form-field class="col-span-2">
      <mat-label>Address</mat-label>
      <input
        formControlName="addressLine1"
        matInput
        [appAddressAutocomplete]="form.value"
        (chosenAddress)="chosenAddress($event)" />
      @if (isGeolocalized() && form.enabled) {
        <mat-icon class="geolocalized-address" matSuffix>pin_drop</mat-icon>
      }
      @if (addressLine1.errors?.required) {
        <mat-error> Address is <b>required</b> </mat-error>
      }
    </mat-form-field>
    <mat-form-field class="col-span-2">
      <mat-label>Address 2</mat-label>
      <input formControlName="addressLine2" matInput />
    </mat-form-field>
    <mat-form-field class="col-span-2">
      <mat-label>Suburb / Town</mat-label>
      <input formControlName="suburb" matInput />
    </mat-form-field>
    @if (country?.value === 'New Zealand') {
      <mat-form-field>
        <mat-label>City</mat-label>
        <input formControlName="city" matInput />
      </mat-form-field>
    }
    @if (country?.value === 'Australia') {
      <mat-form-field>
        <mat-label>State</mat-label>
        <mat-select formControlName="state">
          @for (state of stateOptions; track state) {
            <mat-option [value]="state">{{ state }}</mat-option>
          }
        </mat-select>
        @if (state?.errors?.required) {
          <mat-error> State is <b>required</b> </mat-error>
        }
      </mat-form-field>
    }
    <mat-form-field>
      <mat-label>Postcode</mat-label>
      <input appNumbersOnly formControlName="postCode" matInput maxlength="4" />
      @if (postCode.errors?.required) {
        <mat-error> Post code is <b>required</b> </mat-error>
      }
    </mat-form-field>
  </form>
}
